import styles from '../ActivityDropDown.module.scss'
import cx from 'classnames'
import { forwardRef } from 'react'
import { useDispatch } from 'react-redux'
import {
  updateFilters,
  updateQuery,
} from '../../../actions/dsl-dive-center-actions'
import ActivityCheckbox from './ActivityCheckbox'
import PropTypes from 'prop-types'

const getQuery = (subfilters) =>
  subfilters.reduce((acc, el) => {
    const params = Array.isArray(el.id) ? el.id : [el.id]
    return [...acc, ...params]
  }, [])

const ActivityMultiSelect = forwardRef(
  ({ items, filterHeader, isFilter, activityType, queryName }, ref) => {
    const dispatch = useDispatch()

    const toggleChecked = (name, value, checked) => {
      if(name === 'all') {
        const subfilters = items.map((filter) => {
          return {
            ...filter,
            isChecked: checked,
          }
        })
        const isGroupActive = subfilters.some((el) => el.isChecked)
        const activeQueries = getQuery(subfilters)

        dispatch(
          updateQuery({
            queryName,
            activeQueries,
            isActive: isGroupActive,
          }),
        )

        dispatch(
          updateFilters({
            groupName: filterHeader,
            subfilters,
            activityType,
            isGroupActive,
          }),
        )
      } else {
        const subfilters = items.map((filter) => {
          if(filter.title === 'all') {
            return {
              ...filter,
              isChecked: false,
            }
          }

          if(filter.title === name) {
            return {
              ...filter,
              isChecked: checked,
            }
          }

          return filter
        })
        const isGroupActive = subfilters.some((el) => el.isChecked)
        const activeQueries = value
          .split(',')
          .map((id) => (isNaN(id) ? id : Number(id)))

        dispatch(
          updateQuery({
            queryName,
            activeQueries,
            isActive: checked,
          }),
        )

        dispatch(
          updateFilters({
            groupName: filterHeader,
            subfilters,
            activityType,
            isGroupActive,
          }),
        )
      }
    }

    return (
      <div className={cx(styles.dropDown, styles.activity)} ref={ref}>
        <h4 className={styles.filterHeader}>{filterHeader}</h4>
        {items &&
          items.map(({ id, title, isChecked }) => (
            <ActivityCheckbox
              title={title}
              value={id}
              key={title}
              isChecked={isChecked}
              setChecked={toggleChecked}
            />
          ))}
      </div>
    )
  },
)

export default ActivityMultiSelect

ActivityMultiSelect.propTypes = {
  items: PropTypes.array,
  filterHeader: PropTypes.string,
  isFilter: PropTypes.bool,
  activityType: PropTypes.string,
  queryName: PropTypes.string,
}
